import './Home.css';
import './HomeResponsive.css';
import React, { useEffect, useState } from 'react';

function Home() {
    const [number, setNumber] = useState(0);
    const [number1, setNumber1] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setNumber((previousNumber) => Math.min(previousNumber + 1, 9));
            setNumber1((previousNumber) => Math.min(previousNumber + 1, 20));
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="App-h">
            <section className="content-container" aria-labelledby="home-heading">
                <div className="left-content">
                    <h1 id="home-heading" className="elevating-text">
                        <span className="blue-text">Elevating Tomorrow Through </span>
                        Digital Innovation
                    </h1>

                    <p className="content-paragraph">
                        More than just a software company; we are your strategic partner in driving innovation and growth.
                        We specialise in crafting custom IT solutions that span diverse industries, providing a competitive
                        edge through cutting-edge technology. Our prowess shines particularly in the domain of Insurance and
                        Financial Services Software, where we are the architects behind solutions like claims and case
                        management platforms that redefine efficiency.
                    </p>
                </div>

                <img
                    className="imgonline1"
                    alt="Digital technology and software services"
                    src="/images/Untitled design (5).png"
                />
            </section>

            <section className="content1" aria-labelledby="trust-heading">
                <div className="left-content1">
                    <img
                        className="left-image"
                        src="/images/img-home2.png"
                        alt="Team members joining hands"
                    />
                    <img
                        className="octagon-shape-clip-4"
                        alt=""
                        aria-hidden="true"
                        src="/images/octogon.png"
                    />
                </div>

                <div className="right-content1">
                    <h1 id="trust-heading" className="topic1">
                        <span className="blue-text">Building on Trust,</span> Delivering Excellence
                    </h1>

                    <p className="content-paragraph1">
                        Trust is the cornerstone of our relationships. We take immense pride in the unwavering trust our
                        clients place in us. It is this trust that fuels our commitment to deliver nothing short of exceptional
                        service and game-changing solutions. Together, we do not just build solutions; we build transformative
                        partnerships that shape industries.
                    </p>

                    <a href="/Services">
                        <button type="button" className="btn-services">Our Services</button>
                    </a>
                </div>
            </section>

            <section className="content2" aria-labelledby="journey-heading">
                <div className="right-content2 journey-copy">
                    <div id="journey-heading" className="topic2">
                        <span className="blue-text">Your Journey</span> with Quantechs
                    </div>

                    <p className="para-journey">
                        Where solutions are tailored to fit the contours of your vision. Whether you are navigating the
                        intricacies of finance, seeking to enhance customer relationships or exploring the limitless
                        possibilities of mobility, Quantechs is your compass. Join us on a journey where empowerment meets
                        innovation, and tomorrow&apos;s solutions become today&apos;s reality.
                    </p>

                    <div className="numberBox-h" aria-label="Company statistics">
                        <div className="experience">
                            <div className="blue-box">
                                <div className="text-wrapper2">{number}+</div>
                                <div className="text-wrapper1">years of experience</div>
                            </div>
                        </div>

                        <div className="projects">
                            <div className="blue-box">
                                <div className="text-wrapper4">{number1}+</div>
                                <div className="text-wrapper3">Projects</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="right-content2 journey-media" aria-hidden="true">
                    <img className="leftimage1" src="/images/img-home4.png" alt="" />
                    <img className="octagon-shape-clip-5" alt="" src="/images/octogon.png" />
                </div>
            </section>

            <section className="content3" aria-labelledby="solutions-heading">
                <div className="left-content3">
                    <img
                        className="leftimage2"
                        alt="Technology consulting"
                        src="/images/imgonline-com-ua-shape-hwS9yGvDvkk.png"
                    />

                    <div className="blue-box1">
                        <div className="text-wrapperSmall">Cloud Integration</div>
                    </div>
                    <div className="blue-box2">
                        <div className="text-wrapperSmall">Software Solutions</div>
                    </div>
                    <div className="blue-box3">
                        <div className="text-wrapperSmall">Consulting</div>
                    </div>
                </div>

                <div className="right-content3">
                    <h1 id="solutions-heading" className="topic1">
                        <span className="blue-text">Innovative </span>Solutions
                    </h1>

                    <p className="content-paragraph1">
                        Green code, brighter future. We are committed to crafting software solutions that not only skyrocket
                        success but also leave a lasting positive footprint on our world businesses, society, and Mother Earth.
                    </p>
                </div>
            </section>
        </div>
    );
}

export default Home;
